/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { Voucher } from '../model/voucher';
import { VoucherArticoliCheckDTO } from '../model/voucherArticoliCheckDTO';
import { VoucherCheckDTO } from '../model/voucherCheckDTO';
import { VoucherInfoDTO } from '../model/voucherInfoDTO';
import { VoucherPatchDTO } from '../model/voucherPatchDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VoucherControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Consente di verificare lo stato del voucher rispetto al valore della transazione
     * @param id_slug_comune 
     * @param codice 
     * @param valoreTransazione 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkVoucher(id_slug_comune: string, codice: string, valoreTransazione: number, observe?: 'body', reportProgress?: boolean): Observable<VoucherCheckDTO>;
    public checkVoucher(id_slug_comune: string, codice: string, valoreTransazione: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VoucherCheckDTO>>;
    public checkVoucher(id_slug_comune: string, codice: string, valoreTransazione: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VoucherCheckDTO>>;
    public checkVoucher(id_slug_comune: string, codice: string, valoreTransazione: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling checkVoucher.');
        }

        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling checkVoucher.');
        }

        if (valoreTransazione === null || valoreTransazione === undefined) {
            throw new Error('Required parameter valoreTransazione was null or undefined when calling checkVoucher.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (valoreTransazione !== undefined && valoreTransazione !== null) {
            queryParameters = queryParameters.set('valoreTransazione', <any>valoreTransazione);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VoucherCheckDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/${encodeURIComponent(String(codice))}/check`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di verificare lo stato del voucher e gli articoli annessi in caso di pratica con articoli
     * @param id_slug_comune 
     * @param codice 
     * @param id_negozio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkVoucherArticoli(id_slug_comune: string, codice: string, id_negozio: string, observe?: 'body', reportProgress?: boolean): Observable<VoucherArticoliCheckDTO>;
    public checkVoucherArticoli(id_slug_comune: string, codice: string, id_negozio: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VoucherArticoliCheckDTO>>;
    public checkVoucherArticoli(id_slug_comune: string, codice: string, id_negozio: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VoucherArticoliCheckDTO>>;
    public checkVoucherArticoli(id_slug_comune: string, codice: string, id_negozio: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling checkVoucherArticoli.');
        }

        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling checkVoucherArticoli.');
        }

        if (id_negozio === null || id_negozio === undefined) {
            throw new Error('Required parameter id_negozio was null or undefined when calling checkVoucherArticoli.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_negozio !== undefined && id_negozio !== null) {
            queryParameters = queryParameters.set('id_negozio', <any>id_negozio);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VoucherArticoliCheckDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/${encodeURIComponent(String(codice))}/checkarticoli`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il voucher
     * @param id_slug_comune 
     * @param nomeFileVoucher 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadVoucher(id_slug_comune: string, nomeFileVoucher: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadVoucher(id_slug_comune: string, nomeFileVoucher: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadVoucher(id_slug_comune: string, nomeFileVoucher: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadVoucher(id_slug_comune: string, nomeFileVoucher: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling downloadVoucher.');
        }

        if (nomeFileVoucher === null || nomeFileVoucher === undefined) {
            throw new Error('Required parameter nomeFileVoucher was null or undefined when calling downloadVoucher.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/download/${encodeURIComponent(String(nomeFileVoucher))}`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il voucher passando il nome file come query param
     * @param id_slug_comune 
     * @param nomeFileVoucher 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadVoucherbyQueryParam(id_slug_comune: string, nomeFileVoucher: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadVoucherbyQueryParam(id_slug_comune: string, nomeFileVoucher: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadVoucherbyQueryParam(id_slug_comune: string, nomeFileVoucher: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadVoucherbyQueryParam(id_slug_comune: string, nomeFileVoucher: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling downloadVoucherbyQueryParam.');
        }

        if (nomeFileVoucher === null || nomeFileVoucher === undefined) {
            throw new Error('Required parameter nomeFileVoucher was null or undefined when calling downloadVoucherbyQueryParam.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nomeFileVoucher !== undefined && nomeFileVoucher !== null) {
            queryParameters = queryParameters.set('nomeFileVoucher', <any>nomeFileVoucher);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/downloadvoucher`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di conoscere le informazioni di un voucher per reinviare in fase di sottomissione transazione
     * @param id_slug_comune 
     * @param codice 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoVoucher(id_slug_comune: string, codice: string, observe?: 'body', reportProgress?: boolean): Observable<Array<VoucherInfoDTO>>;
    public getInfoVoucher(id_slug_comune: string, codice: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<VoucherInfoDTO>>>;
    public getInfoVoucher(id_slug_comune: string, codice: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<VoucherInfoDTO>>>;
    public getInfoVoucher(id_slug_comune: string, codice: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getInfoVoucher.');
        }

        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling getInfoVoucher.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<VoucherInfoDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/${encodeURIComponent(String(codice))}/info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di conoscere le informazioni dei voucher con codici passati in input
     * @param id_slug_comune 
     * @param voucherCodici 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfosVoucher(id_slug_comune: string, voucherCodici: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<VoucherInfoDTO>>;
    public getInfosVoucher(id_slug_comune: string, voucherCodici: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<VoucherInfoDTO>>>;
    public getInfosVoucher(id_slug_comune: string, voucherCodici: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<VoucherInfoDTO>>>;
    public getInfosVoucher(id_slug_comune: string, voucherCodici: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getInfosVoucher.');
        }

        if (voucherCodici === null || voucherCodici === undefined) {
            throw new Error('Required parameter voucherCodici was null or undefined when calling getInfosVoucher.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (voucherCodici) {
            voucherCodici.forEach((element) => {
                queryParameters = queryParameters.append('voucherCodici', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<VoucherInfoDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/info/codici`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare alcuni parametri di un tipo pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codice 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchVoucher(body: VoucherPatchDTO, id_slug_comune: string, codice: string, observe?: 'body', reportProgress?: boolean): Observable<Voucher>;
    public patchVoucher(body: VoucherPatchDTO, id_slug_comune: string, codice: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Voucher>>;
    public patchVoucher(body: VoucherPatchDTO, id_slug_comune: string, codice: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Voucher>>;
    public patchVoucher(body: VoucherPatchDTO, id_slug_comune: string, codice: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchVoucher.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchVoucher.');
        }

        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling patchVoucher.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Voucher>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/voucher/${encodeURIComponent(String(codice))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
